export default __webpack_public_path__ + "static/header-fale-conosco-e455e4682d73dd7ee0331041afd9fc28.png";